module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-7-min.8d3426e1.jpg";